define([
	'lib/jquery'
], function (
	jQuery
) {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d'),
			_dots = 11,
			_radius = 4,
			_spacing = 20,
			_animation = false,
			_animationTimer;

		setDots();

		window.addEventListener('resize', function () {
			if (jQuery('body').find(_canvas).length !== 0) {
				var animation = _animation;

				setDots();

				if (animation) {
					_animation = true;

					animate();
				}
			}
		});


		// private methods

		function setDots() {
			if (window.innerWidth <= 400) {
				_dots = 3;
			} else if (window.innerWidth <= 600) {
				_dots = 6;
			} else {
				_dots = 11;
			}

			_context.canvas.height = _radius * 2;
			_context.canvas.width = (_dots - 1) * _spacing + _radius * 2;

			reset();
		}

		function animate(loop) {
			var dotsLoop = 0;

			if (!_animation) {
				return;
			}

			if (typeof loop === 'undefined') {
				loop = 0;
			}

			_context.clearRect (0, 0, (_dots - 1) * _spacing + _radius * 2, _radius * 2);
			_context.fillStyle = '#000000';
			_context.save();

			while ((dotsLoop * _spacing + _radius) <= (_dots - 1) * _spacing + _radius) {
				if (loop == dotsLoop) {
					_context.fillStyle = '#C9C9C9';
					_context.save();
				}

				_context.beginPath();
				_context.arc((dotsLoop * _spacing + _radius), _radius, _radius, 0, 2 * Math.PI, true);
				_context.closePath();
				_context.fill();

				dotsLoop++;
			}

			_animationTimer = window.setTimeout(function () {
				animate(loop == _dots ? 0 : ++loop);
			}, 500);
		}

		function reset() {
			var dotsLoop = 0;

			window.clearTimeout(_animationTimer);

			_animation = false;

			_context.fillStyle = '#C9C9C9';
			_context.save();

			while ((dotsLoop * _spacing + _radius) <= (_dots - 1) * _spacing + _radius) {
				_context.beginPath();
				_context.arc((dotsLoop * _spacing + _radius), _radius, _radius, 0, 2 * Math.PI, true);
				_context.closePath();
				_context.fill();

				dotsLoop++;
			}
		}


		// public methods

		this.get = function () {
			return _canvas;
		};

		this.reset = function () {
			reset();
		};

		this.enableAnimation = function () {
			if (_animation) {
				return;
			}

			_animation = true;

			animate();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/ConnectionCanvas.js
// module id = 319
// module chunks = 1